import { useContext, useEffect, useRef, useState } from 'react';
import Button from './Button';
import ModalNotice from './ModalNotice';
import FeedbackContext from '@/contexts/feedback';
import useGetSystemNotice from '@/hooks/useGetSystemNotice';
import * as styleHomePage from '@/styles/components/Notice';

const SystemNotice = () => {
  const { notice } = useGetSystemNotice();
  const refNotice = useRef<HTMLDivElement>(null);
  const { setHeightNotice } = useContext(FeedbackContext);
  const [visible, setVisible] = useState<boolean>(false);
  const [showTarget, setShowTarget] = useState<boolean>(false);
  const [isBetweenTime, setIsBetweenTime] = useState<boolean>(false);
  const getIdNotice = typeof window !== 'undefined' ? localStorage.getItem('spohabi_notice') : null;
  const handleClose = () => {
    setVisible(false);
  };

  useEffect(() => {
    if (notice) {
      if (Number(getIdNotice) !== notice.id || !getIdNotice) {
        if (notice.modal_title || notice.modal_content) {
          setVisible(true);
        }
      }

      if (notice.notice_target === 1 || notice.notice_target === 2) {
        setShowTarget(true);
      }

      const dateTimeNow = new Date();
      const result = dateTimeNow >= new Date(notice.start_datetime) && dateTimeNow <= new Date(notice.end_datetime);
      if (result) {
        setIsBetweenTime(true);
      }
    }
  }, [getIdNotice, notice]);

  useEffect(() => {
    const updateHeight = () => {
      if (refNotice.current) {
        setHeightNotice(refNotice.current.clientHeight);
      }
    };
    window.addEventListener('resize', updateHeight);
    updateHeight();
    return () => window.removeEventListener('resize', updateHeight);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showTarget, isBetweenTime]);

  useEffect(() => {
    if (visible) {
      localStorage.setItem('spohabi_notice', String(notice?.id));
    }
  }, [notice?.id, visible]);

  return notice && showTarget && isBetweenTime ? (
    <>
      <div
        onClick={() => {
          if (notice.modal_title || notice.modal_content) {
            setVisible(true);
          }
        }}
        css={styleHomePage.lstSystemNotice}
        ref={refNotice}>
        <div key={notice?.id} css={styleHomePage.systemNoticeGroup}>
          <div css={styleHomePage.lableSystemNotice}>{notice?.label}</div>
          <div css={styleHomePage.contentSystemNotice}>{notice?.content}</div>
        </div>
      </div>
      <ModalNotice visible={visible} title={notice.modal_title || ''} handleClose={handleClose}>
        <ModalNotice.Body>
          <div css={styleHomePage.contentModalSystemNotice}>{notice.modal_content || ''}</div>
        </ModalNotice.Body>
        <ModalNotice.Footer>
          <ModalNotice.Footer>
            <Button
              variant='outlined'
              type='button'
              color='#5F5E62'
              borderColor='#5F5E62'
              size='lg'
              handleClick={handleClose}>
              閉じる
            </Button>
          </ModalNotice.Footer>
        </ModalNotice.Footer>
      </ModalNotice>
    </>
  ) : null;
};

export default SystemNotice;
